import React, { Component } from 'react';
import * as Icon from '../Icons';
import Header from '../header/Header';
import Text from '../Text';
import localization from '../localization';
import './More.css';

const supportsNativeShare = navigator.share !== undefined;
const appName = encodeURIComponent(document.title);
const shareUrl = encodeURIComponent(window.location.origin);

export default class More extends Component {
	render() {
        const currentLang = localization.currentLanguage;
        const languages = ['en', 'de'];
		return (
            <div>
                <Header page="nav_more" />
                <div className="more">
                    <h3><Text>more_headline_lang</Text></h3>
                    <div className="block-select">
                        <select value={currentLang} onChange={(event) => { localization.currentLanguage = event.target.value; }}>
                        {languages.map(lang => <option value={lang}>{lang}</option>)}
                        </select>
                    </div>

                    <div className="radio-btn-group">

                    </div>

                    <h3><Text>more_headline_feedback</Text></h3>
                    <p><Text>more_copy_feedback</Text></p>
                    <a href="" className="block-button"><Icon.Github /> <Text>more_btn_github</Text></a>

                    <h3><Text>more_headline_share</Text></h3>
                    { supportsNativeShare && (
                        <button
                            className="block-button"
                            onClick={() => {
                                navigator.share({
                                    title: document.title,
                                    url: window.location.origin
                                });
                            }}
                        >
                            <Icon.Share />
                            <Text>more_btn_nativeshare</Text>
                        </button>
                    )}

                    { !supportsNativeShare && (
                        <div>
                            <a href={`https://www.facebook.com/share.php?u=${shareUrl}`} className="block-button"><Icon.Facebook /> <Text>more_btn_facebook</Text></a>
                            <a href={`https://twitter.com/intent/tweet?url=${shareUrl}&text=${appName}`} className="block-button"><Icon.Twitter />
                             <Text>more_btn_twitter</Text></a>
                            <a href={`whatsapp://send?text=${appName}%0D%0A${shareUrl}`} className="block-button"><Icon.Whatsapp /> <Text>more_btn_whatsapp</Text></a>
                            <a href={`mailto:?&subject=${appName}&body=${appName}%0D%0A${shareUrl}`} className="block-button"><Icon.Email /> <Text>more_btn_mail</Text></a>
                        </div>
                    )}
                    <h3><Text>more_headline_misc</Text></h3>
                    <a href="https://jankohofmann.de/impressum/" className="block-button"><Text>more_btn_imprint</Text></a>
                    <a href="" className="block-button"><Text>more_btn_sources</Text></a>

                </div>
            </div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/more/More.js